<template>
  <div class="account-controls">
    <PageSwitch />
    <NotificationsMenu />
    <CollectionsMenu />
    <FavoritesMenu />
    <ProfileMenu :user-data="userData" />
    <div v-for="(toast, index) in toasts" :key="index">
      <BbToastMessage
        :modelValue="!!toast"
        :title="toast.title"
        duration="4000"
        location="top centre"
        @update:modelValue="clearCurrentToast(toast.notification.externalId)"
      />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import useNotifications from '~/composables/useNotifications';

import { GetUserData } from '~/constants/getters';

import ProfileMenu from '~/components/account/ProfileMenu';
import FavoritesMenu from '~/components/account/FavoritesMenu';
import NotificationsMenu from '~/components/account/NotificationsMenu';
import CollectionsMenu from '~/components/account/CollectionsMenu';
import PageSwitch from '~/components/common/PageSwitch';

export default {
  name: 'AccountControls',
  components: {
    PageSwitch,
    CollectionsMenu,
    NotificationsMenu,
    FavoritesMenu,
    ProfileMenu,
  },

  setup() {
    const { toasts, removeToastById } = useNotifications();
    const store = useStore();
    const userData = computed(() => store.getters[`authStore/${GetUserData}`]);

    const clearCurrentToast = (index) => {
      removeToastById(index);
    };

    return {
      clearCurrentToast,
      toasts,
      userData,
    };
  },
};
</script>

<style scoped lang="scss">
.account-controls {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: $bb-spacing-2;
  gap: $bb-spacing-4;
}

.notification {
  margin-right: $bb-spacing-5;
}
</style>
